angular.module('signalview.sharing', ['signalview.detector.rule', 'sfx.data']);
